import { createPDF } from '../Pdf';

export default async function generate(html: string) {
  try {
    // let filePath =
    await createPDF('tempDocToImage', html);
  } catch (err) {
    console.log(err);
  }
}
